import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";
import Settings from "../../models/Settings";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last ? last : 0
      });
    },
    async pingAccountLevelDisplay(context) {
      let store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/account/ping`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        let oldSettings = store.getters["entities/settings/query"]().first();

        // account balance
        oldSettings.balance = response.data.balance;

        // call notifications
        oldSettings.callIsUnreadCount = response.data.callIsUnreadCount;
        oldSettings.callIsArchivedCount = response.data.callIsArchivedCount;

        // message notifications
        oldSettings.messageIsUnreadCount = response.data.messageIsUnreadCount;
        oldSettings.messageIsSnoozedCount = response.data.messageIsSnoozedCount;
        oldSettings.messageIsArchivedCount =
          response.data.messageIsArchivedCount;

        // below is temp until we include messages have not reponded counts in indicators
        oldSettings.messageHaveNotRespondedCount = 0;
        // oldSettings.messageHaveNotRespondedCount =
        //   response.data.messageHaveNotRespondedCount;

        // chat notifications
        oldSettings.chatIsNotEndedCount = parseInt(
          response.data.chatIsNotEndedCount
        );
        oldSettings.chatIsUnreadCount = parseInt(
          response.data.chatIsUnreadCount
        );
        oldSettings.chatHaveNotRespondedCount = parseInt(
          response.data.chatHaveNotRespondedCount
        );
        oldSettings.isOffline = false;
        oldSettings.id = 1;

        store.dispatch("entities/settings/create", { data: oldSettings });
      } catch (error) {
        console.error("pingAccountLevelDisplay " + error);
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async getFileUrl(context, externalId, path) {
      let response = await axios({
        method: "get",
        url:
          API_BASE_URL +
          `/account?do=file-url&externalId=${externalId}&path=${path}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      });
      return response ? response.url : null;
    },

    async createAccount(context, account) {
      if (account.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/account`,
            data: {
              name: account.name,
              primaryPhone: account.primaryPhone
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/accounts/delete", {
            where: account.tempId
          });
          store.dispatch("entities/accounts/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },
    async updateAccount(context, account) {
      if (account.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/account/${account.id}`,
            data: {
              name: account.name,
              primaryPhone: account.primaryPhone
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/accounts/update", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/account?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let accounts = [];
    obj.forEach(function(account) {
      accounts.push({
        id: account.id,
        name: account.name,
        externalId: account.externalId,
        primaryPhone: account.primaryPhone,
        isDirty: false,
        createdAt: Date.parse(account.createdAt),
        updatedAt: Date.parse(account.updatedAt)
      });
    });
    if (accounts.length > 0) {
      store.dispatch("entities/accounts/insert", {
        data: accounts
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
